<template>
  <v-row column>
    <v-col cols="12">
      <v-row row align-center>
        <v-col cols="4" class="pt-0 pb-0">
          <span class="subtitle-1 font-weight-regular">
            File name:
          </span>
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <span class="subtitle-1 font-weight-regular">
            Type:
          </span>
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <span class="subtitle-1 font-weight-regular">
            Size:
          </span>
        </v-col>
      </v-row>
      <v-row
        align-center
        v-for="item in files"
        :key="item.name"
      >
        <v-col cols="4" class="text-truncate pr-3 pt-0 pb-0">
          {{ item.name }}
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          {{ item.type }}
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          {{ parseInt(item.file.size / 1024 / 1024, 10) }} Mb
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-row>
            <v-col shrink class="pr-3 pt-0 pb-0">
              <span
                class="subtitle-2 font-weight-light"
                v-if="item.state">
                  &emsp;{{ item.state }}
              </span>
            </v-col>
            <v-col grow>
              <v-progress-linear
                :active="item.progress > 0"
                :value="item.progress"
                :color="processingState(item.stateVal)"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="item.url" class="pt-0 pb-0">
          <span>&emsp;</span>
          <a
            target="_blank"
            v-bind:href="item.url"
          >
            <span class="">{{item.url}}</span>
          </a>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

export default {
  props: {
    files: {
      type: Array,
      required: true,
    },
    processing: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    processingState(val) {
      if (val === 1) return 'yellow darken-2';
      if (val === 2) return 'green darken-2';
      if (val === 3) return 'red darken-2';
      return 'green darken-2';
    },
  },
};
</script>

<style scoped>
</style>
